import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";
import { SelectField } from "@/components/ui/form/fields/select-field";
import { Label } from "@/components/ui/label/label";

import { BankAccountTypeOptions } from "./constants";

type Props = {
	bankCode: string;
	bankCodeErrorMessage?: string;
	bankBranchCode: string;
	bankBranchCodeErrorMessage?: string;
	bankAccountType: string;
	bankAccountTypeErrorMessage?: string;
	bankAccountNumber: string;
	bankAccountNumberErrorMessage?: string;
	bankAccountHolderName: string;
	bankAccountHolderNameErrorMessage?: string;

	onChangeBankCode: (value: string) => void;
	onChangeBankBranchCode: (value: string) => void;
	onChangeBankAccountType: (value: string) => void;
	onChangeBankAccountNumber: (value: string) => void;
	onChangeBankAccountHolderName: (value: string) => void;
};

export const RemittanceAccountForm = ({
	bankCode,
	bankCodeErrorMessage,
	bankBranchCode,
	bankBranchCodeErrorMessage,
	bankAccountType,
	bankAccountTypeErrorMessage,
	bankAccountNumber,
	bankAccountNumberErrorMessage,
	bankAccountHolderName,
	bankAccountHolderNameErrorMessage,

	onChangeBankCode,
	onChangeBankBranchCode,
	onChangeBankAccountType,
	onChangeBankAccountNumber,
	onChangeBankAccountHolderName,
}: Props) => {
	return (
		<div className="flex w-full flex-col gap-x-6 p-5 md:flex-row">
			<div className="grid w-full max-w-52 flex-none">
				<div className="mt-2">
					<div className="flex items-center gap-2">
						<h5>送金先口座の登録</h5>
						<Label text="必須" size="sm" />
					</div>
				</div>
			</div>

			<div className="mt-3 w-full space-y-4 md:max-w-md">
				<div className="flex gap-x-6">
					<div className="w-full md:min-w-40">
						<div className="mt-1">
							<InputTextField
								label="金融機関コード（4桁）"
								placeholder="0001"
								value={bankCode}
								errorMessage={bankCodeErrorMessage}
								handleChange={(value) => onChangeBankCode(value)}
							/>
						</div>
					</div>

					<div className="w-full md:min-w-40">
						<p className="text-base-ordinary text-sm text-[#4c4c4c]"></p>
						<div className="mt-1">
							<InputTextField
								label="支店コード"
								placeholder="001"
								value={bankBranchCode}
								errorMessage={bankBranchCodeErrorMessage}
								handleChange={(value) => onChangeBankBranchCode(value)}
							/>
						</div>
					</div>
				</div>

				<div className="w-full">
					<div className="mt-1">
						<SelectField
							label="口座種類"
							value={bankAccountType}
							errorMessage={bankAccountTypeErrorMessage}
							options={BankAccountTypeOptions}
							handleValueChange={(value) => onChangeBankAccountType(value)}
						/>
					</div>
				</div>

				<div className="w-full">
					<div className="mt-1">
						<InputTextField
							label="口座番号（7桁）"
							placeholder="1234567"
							value={bankAccountNumber}
							errorMessage={bankAccountNumberErrorMessage}
							handleChange={(value) => onChangeBankAccountNumber(value)}
						/>
					</div>
					<div className="mt-2">
						<p className="text-xs text-caption-50">※口座番号が7桁に満たない場合、頭に0を加えてください</p>
					</div>
				</div>

				<div className="w-full">
					<div className="mt-1">
						<InputTextField
							label="口座名義(カナ)"
							placeholder="ヤマダタロウ"
							value={bankAccountHolderName}
							errorMessage={bankAccountHolderNameErrorMessage}
							handleChange={(value) => onChangeBankAccountHolderName(value)}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
